import { render, staticRenderFns } from "./PageNav.vue?vue&type=template&id=3c64da38&scoped=true"
import script from "./PageNav.vue?vue&type=script&lang=js"
export * from "./PageNav.vue?vue&type=script&lang=js"
import style0 from "./PageNav.vue?vue&type=style&index=0&id=3c64da38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c64da38",
  null
  
)

export default component.exports